import {
    get_dispositiviSicurezza,
    get_dispositivoSicurezza,
    get_dispositivoSicurezza_kpi,
    create_dispositivoSicurezza,
    update_dispositivoSicurezza,
    duplica_dispositivoSicurezza,
    delete_dispositivoSicurezza,
} from "@/api/api.dispositivosicurezza.js";

const dispositiviSicurezza = {
    namespaced: true,

    state: {
        lista: [],
        corrente: null,
        kpi: null,
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
        SET_CORRENTE: (state, dispositivo) => {
            state.corrente = dispositivo;
        },
        SET_KPI: (state, kpi) => {
            state.kpi = kpi;
        },
    },

    actions: {
        carica({ commit }, filtri) {
            return new Promise((resolve, reject) => {
                get_dispositiviSicurezza(filtri).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_dispositivoSicurezza(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaKpi({ commit }) {
            return new Promise((resolve, reject) => {
                get_dispositivoSicurezza_kpi().then(resp => {
                    commit("SET_KPI", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva(_ctx, { id, dati }) {
            return id ? update_dispositivoSicurezza(id, dati) : create_dispositivoSicurezza(dati);
        },

        elimina(_ctx, { id, conferma } = {}) {
            return delete_dispositivoSicurezza(id, conferma);
        },

        duplica(_ctx, id) {
            return duplica_dispositivoSicurezza(id);
        },
    },

    getters: {
        lista: state => state.lista,
        corrente: state => state.corrente,
        kpi: state => state.kpi,
    },
};

export default dispositiviSicurezza;
